<div class="sidebar" [class.collapsed]="!isFullSidebar">
    <div class="sidebar__header">
        <div class="text-center sidebar__logo">
            <img [src]="getLogoPath()" [width]="isFullSidebar ? 160 : 46" alt="Logo" />
        </div>
    </div>
    <ul class="m-0 mt-4 sidebar__ul">
        @for(menu of menus; track menu){
            @if(menu.enable){
                <li class="mb-1">
                    <a 
                        href="javascript:void(0)" 
                        class="sidebar__nav text-capitalize" 
                        [routerLink]="[menu.route]" 
                        [routerLinkActive]="['active']">
                        <span class="sidebar__navName">{{menu.name}}</span>
                        <i class="bi bi-arrow-right sidebar__navIcon"></i>
                        <i [class]="menu.icon" class="bi sidebar__navIconLarge"></i>
                    </a>
                </li>   
            }
        }
        @if(userRole !== 99){
            <li class="mb-1">
                <a [href]="openDockLink" target="_blank" class="sidebar__nav">
                    <span class="sidebar__navName">{{labels.menu.openDock}}</span>
                    <i class="bi bi-arrow-up-right-circle sidebar__navIcon"></i>
                    <i class="bi bi-calendar-week sidebar__navIconLarge"></i>
                </a>
            </li>
        }
    </ul>
    <div class="d-flex justify-content-end px-3 py-5">
        <button type="button" class="sidebar__toggle" [title]="isFullSidebar? 'Collapse Menu' : 'Expand Menu'" (click)="toggle()">
            <i class="bi" [class]="isFullSidebar? 'bi-arrow-left-square' : 'bi-arrow-right-square'"></i>
        </button>
    </div>
</div> 